module.exports = __webpack_public_path__ + "static/media/safari.8c87abbb.jpeg";